import { render, staticRenderFns } from "./ModelHome.vue?vue&type=template&id=5aae0bf4&"
import script from "./ModelHome.vue?vue&type=script&lang=js&"
export * from "./ModelHome.vue?vue&type=script&lang=js&"
import style0 from "./ModelHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports